exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.no-link-style {\n  text-decoration: initial;\n  color: initial;\n}\na.no-link-style:hover,\na.no-link-style:focus,\na.no-link-style:focus-visible {\n  text-decoration: initial;\n  color: initial;\n}\n", ""]);

// exports
